module.exports = __webpack_public_path__ + "img/introduce-icon1.c6ca19dd.svg";